

export const UserBookCreateGuide = ({ onNextStep = f => f }) => {
    return (
        <div className="step inner guideStep">
            <div className="row">
                <div className="col6 col-md-12 guideImage">
                    <img src={`${process.env.PUBLIC_URL}/static/images/userbook/hello_bookgomi.gif`} alt="작품 새로만들기 안내" />
                </div>
                <div className="col6 col-md-12">
                    <div className="guideBox">
                        <h3 className="title">북고미는 작가님의 새 작품을 기대하고,<br />열심히 응원할게요!</h3>
                        <ol>
                            <li>다음 회차 연재시 <span>내 작품</span>&#62;<span>다음화 만들기</span>를 눌러주세요.</li>
                            <li>작품 내용의 길이는 <span>300자이상</span>입니다.</li>
                            <li>창작 회차는 독서사과 <span>한 개</span> 획득, 비창작은 독서사과가 <span>없습니다.</span></li>
                            <li>남의 창작물(글과 그림)을 배끼면 안돼요. <span>삭제</span>될수 있어요</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div data-aos="fade-zoom-in" data-aos-delay="1000" data-aos-duration="1000">
                <button className="btn _red" onClick={(e) => {
                    if (!window.confirm("창작으로 작품을 생성하시겠습니까?")) return;
                    onNextStep('Y', 2);
                }}>창작</button>
                &nbsp;
                <button className="btn _blue" onClick={(e) => {
                    if (!window.confirm("비창작으로 작품을 생성하시겠습니까? 사과를 받을 수 없습니다.")) return;
                    onNextStep('N', 3);
                }}>비창작</button>
            </div>
        </div>
    );
}
